import {  createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface iCommonUserParameterState {
    library_name: string;
    round_num: number;
}

const initialState: iCommonUserParameterState = {
    library_name: "",
    round_num: null,  
};

export const commonUserParameterSlice = createSlice({
    name: "commonUserParameter",
    initialState,
    reducers: {
        setCommonLibraryName: (state, action: PayloadAction<{ library_name: string }>) => {
            state.library_name = action.payload.library_name;
        },
        setCommonRoundNum: (state, action: PayloadAction<{ round_num: number }>) => {
            state.round_num = action.payload.round_num;
        },
    },
});

export const { setCommonLibraryName, setCommonRoundNum } = commonUserParameterSlice.actions;
export default commonUserParameterSlice.reducer;